import api from '../../../../../../../configurations/service';
import * as types from './mutation-types';

export const setStoneConfigurated = async (context) => {
  const { data } = await api().post('fiscal.get-stone-configuration');
  if (data.active) {
    context.commit(types.SET_STONE_CONFIGURATED, true);
  }
};

export const createCobStone = async (context, nfeId) => {
  const { data } = await api().post('fiscal.post-stone-create-cob', { nfeId });
  return data;
};

export const cancelCobStone = async (context, id) => {
  const { data } = await api().post('fiscal.post-stone-order-closed', { id });
  return data;
};

export const consultCobStone = async (context, nfeId) => {
  const { data } = await api().post('fiscal.post-stone-consult-cob', { nfeId });
  return data;
};

export const consultCobStoneWebhook = async (context, nfeId) => {
  const { data } = await api().post('fiscal.post-stone-consult-cob-webook', { nfeId });
  return data;
};

export const printDocStone = async (context, nfeId) => {
  const { data } = await api().post('fiscal.post-stone-print-cob', { nfeId });
  return data;
};
